import { render, staticRenderFns } from "./QuizPanel.vue?vue&type=template&id=8216bb8c&"
import script from "./QuizPanel.vue?vue&type=script&lang=js&"
export * from "./QuizPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports